import React, { useEffect, useState } from 'react';
import { Table, Dropdown, Menu, Checkbox, Modal, Button, Space, Input, Form, message } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { EllipsisOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { payoutDataWithPartner, remarkData, partnerChangeHistoryData } from '../helper/payoutdatasample';
import { render } from '@testing-library/react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import PartnerChangeHistory from '../PartnerChangeHistory';
import RemarksComponent from '../RemarksComponent';
import AddInvoice from '../AddInvoice';
import { connect } from 'react-redux';
import { addPayoutRemarksSuccess, getPayoutRemarksSuccess } from '../../../redux/PayoutPartnerData/action';
import { getRaisePayoutQueryInternalAction } from '../../../redux/PayoutQueryInternal/Action';
import { partnerApprovalStagesSuccess } from '../../../redux/PayoutApprovalStages/action';
import { getInvoiceData } from '../../../redux/PayoutPartnerInvoiceUpload/Action';
import { Payout_Service } from '../../../redux/Url';
import { Spin } from 'antd';


const PartnerListWithPayoutChecker = (props) => {

  const {
    landataSource,
    setLanDatasource,
    makerAction,
    checkerAction,
    utrAction,
    setMakerAction,
    setCheckerAction,
    handleRadioChange,
    radiostate,
    setRadioState,
    handleCheckboxChange,
    selectedCheckboxes,
    pagination,
    ReportId,
    currentStage,
    fetchPaginatedData,
    fetchPayoutStagesData,
    multiQueryReamark,
    setMultiQueryRemark,
    loading,

  } = props;

  const [form] = Form.useForm();
  const [datasource, setDatasource] = useState([]);
  const [invoiceData, setInvoiceData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [value, setValue] = useState('');
  const [partnerChangeOpen, setPartnerChangeOpen] = useState(false);
  const [partnerChangeData, setPartnerChangeData] = useState(partnerChangeHistoryData);
  const [remarks, setRemarks] = useState(false);
  const [remarkText, setRemarkText] = useState('');
  const [addQueryOpen, setAddQueryOpen] = useState(false);
  const [addOpenQuery, setAddOpenQuery] = useState(false);
  const [selectedPartnerId, setSelectedPartnerId] = useState(null);
  const [partnerRemarks, setPartnerRemarks] = useState([]);
  const [queryPartnerId, setQueryPartnerId] = useState(null);
  const [remarkComment, setRemarkComment] = useState('');
  const [documentDatalength, setDocumentDataLength] = useState();
  const [approveRemarks, setApproveRemarks] = useState('');
  const [isApproveModal, setIsApproveModal] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [isRemarksLoading, setIsRemarksLoading] = useState(null);
  const { monthlyReportId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setDatasource(landataSource);
  }, [landataSource, radiostate]);



  const handleSelectAllChange = (e, action) => {
    const checked = e.target.checked;
  }

  const handleMenuClick = (record, action) => {
  };




  // Fetch remarks for a partner
  const fetchPartnerRemarks = async (partnerId) => {
    try {


      const getRemarks = await props.getPayoutRemarks({
        accessToken: props.accessToken,
        reportId: ReportId, // Assuming ReportId is the report ID you want to use
        partnerId: partnerId,
      })
      const data = await getRemarks;
      setPartnerRemarks(data || []); // Assuming the API returns data in a 'data' field
      // Optionally dispatch to Redux if needed:
      // props.getPayoutRemarksSuccess(data);
      return data;
    } catch (error) {
      setPartnerRemarks([]);
      return [];
    }
  };

  const handleRemarksModal = async (partnerId, key) => {
    setIsRemarksLoading(key);
    setSelectedPartnerId(partnerId);
    setPartnerRemarks([]);
    setRemarks(true);
    await fetchPartnerRemarks(partnerId);
    setIsRemarksLoading(null);
  };

  const handelAddRemarks = async (remarkComment, partnerId = selectedPartnerId) => {



    const remarksData = {
      "partnerId": partnerId,
      "reportId": ReportId,
      "userId": props.userDetail?.userId,
      "remarksComment": remarkComment,
      "stage": currentStage,
      "remarkType": "Partner"
    };
    const resReamatkadd = await props.PartnerRemarkadd({
      accessToken: props.accessToken,
      remarks: remarksData
    });

    await fetchPartnerRemarks(partnerId);

  }

  const formatRemarks = (remarks) => {
    const sortdata = remarks.sort((a, b) => {
      const dateA = new Date(a.createDateTime);
      const dateB = new Date(b.createDateTime);

      // For debugging

      return dateA.getTime() - dateB.getTime(); // Newest first
    });
    return remarks
      ?.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))
      .map((remarks) => (
        <div className='containerRemarks' style={{ display: 'block' }} key={remarks.userName}>
          <div style={{ display: 'flex' }}>
            <b>{remarks.userName}</b>
            <b className='userRole' >({remarks.userRole})</b>
          </div>
          <div style={{ display: 'grid' }} className='commentContainer'>
            <span style={{ maxWidth: "200px" }}> {remarks.remarksComment} </span>
            <small>
              {new Date(remarks.createDateTime).toLocaleString()}
            </small>
          </div>
        </div>
      ));
  };

  var resData = formatRemarks(remarkData);


  const fetchInvoicedata = async (reportdata) => {

    const invoicedata = await props.getInvoiceData({
      accessToken: props.accessToken,
      partnerId: reportdata.partnerId,
      reportId: ReportId,
    })


    setInvoiceData(invoicedata?.data?.invoiceDetails);

  }

  const handleInvoiceModal = async (data) => {
    setIsModalOpen(true);
    const rest = await fetchInvoicedata(data);
    // setInvoiceData(data);

  };

  const handleCancel = () => {
    form.resetFields();
    setAddQueryOpen(false);
    setAddOpenQuery(false);
    setIsApproveModal(false);

  };





  const handleSubmit = (value, record) => {
    // printing the value on save

    // clear the value after set
    setValue('');
  }

  // const handleChange = (event) => {
  //   console.log("handleChange" + event.target.value)
  //   setValue(event.target.value)
  // }

  // const handleQueryRemark = () => {
  //   console.log("Submit query remark...")
  // }

  const handleHeaderMenuClick = async (key) => {
    switch (key) {
      case 'ExportCSV':
        await downloadReport('csv');
        break;

      case 'ExportExcel':
        await downloadReport('excel');
        break;
      // case 'AddRemark':
      //   console.log('Adding remark...');
      //   setRemarks(true)
      //   break;
      case 'PartnerChangeHistory':
        setPartnerChangeOpen(true)
        break;
      case 'Query':
        // setAddQueryOpen(true)
        break;
      default:
        break;
    }
  };

  const handelQueryRemarkClick = (parentId) => {

    setAddQueryOpen(true)
    setQueryPartnerId(parentId);

  }

  const handelQueryRemarkInvoice = (parentId) => {

    setAddOpenQuery(true)
    setQueryPartnerId(parentId);

  }

  const handleQueryRemarkSubmit = async () => {
    setIsLoading(true);
    if (remarkComment.trim() === '') {
      message.error('Please enter a remark before submitting.'); // Show error message
      form.resetFields(); // Reset form fields
      setRemarkComment(''); // Clear the remark input
      return; // Prevent submission if remark is empty
    }
    // const getpartnerIds = Object.keys(selectedCheckboxes.Check).length > 0 ? selectedCheckboxes.Check.map(item => item.partnerId) : [selectedPartnerId];
    const parentIdq = queryPartnerId;
    const queryData = {
      "partnerid": [parentIdq],
      "reportid": ReportId,
      "userId": props.userDetail?.userId,
      "stage": currentStage,
      "payoutid": [],
      "remarks": {
        "partnerId": parentIdq,
        "reportId": ReportId,
        "userId": props.userDetail?.userId,
        "remarksComment": remarkComment,
        "stage": 7,
        "remarkType": "PartnerQuery"
      }
    };

    const resQuery = await props.RaiseQuery({
      accessToken: props.accessToken,
      query: queryData
    });
    await new Promise(resolve => setTimeout(resolve, 500)); // Wait for 500ms to ensure the message is displayed
    message.success('Query raised successfully!'); // Show success message
    form.resetFields();
    setRemarkComment('');
    setAddOpenQuery(false);
    fetchPayoutStagesData(); // Refresh the stages data
    fetchPaginatedData(currentStage, radiostate); // Refresh the data after submission
    setQueryPartnerId(null);
    setIsLoading(false);

  }

  const setMultipleQueryRemark = async () => {
    const partner = queryPartnerId;
    const Remark = remarkComment;


    setMultiQueryRemark(prev => {
      const existingIndex = prev.findIndex(item => item.partnerId === partner);
      if (existingIndex !== -1) {
        // Create a new array with the updated remark
        const updated = [...prev];
        updated[existingIndex] = { ...updated[existingIndex], Remark };
        form.resetFields();
        setAddQueryOpen(false);
        return updated;
      } else {
        form.resetFields();
        setAddQueryOpen(false);
        return [...prev, { partnerId: partner, Remark }];
      }
    });
    message.success('Query remark saved successfully!'); // Show success message
    form.resetFields();
    setQueryPartnerId(null);
  };

  // internal raise query
  const handleQueryRemark = async () => {
    if (remarkComment.trim() === '') {

      message.error('Please enter a remark before submitting.'); // Show error message
      form.resetFields(); // Reset form fields
      setRemarkComment(''); // Clear the remark input
      return; // Prevent submission if remark is empty
    }
    // const getpartnerIds = Object.keys(selectedCheckboxes.Check).length > 0 ? selectedCheckboxes.Check.map(item => item.partnerId) : [selectedPartnerId];
    const parentIdq = queryPartnerId;
    const queryData = {
      "partnerid": [parentIdq],
      "reportid": ReportId,
      "userId": props.userDetail?.userId,
      "stage": currentStage,
      "payoutid": [],
      "remarks": {
        "partnerId": parentIdq,
        "reportId": ReportId,
        "userId": props.userDetail?.userId,
        "remarksComment": remarkComment,
        "stage": 1,
        "remarkType": "InternalQuery"
      }
    };

    const resQuery = await props.RaiseQuery({
      accessToken: props.accessToken,
      query: queryData
    });

    setRemarkComment('');
    setAddQueryOpen(false);
    fetchPayoutStagesData(); // Refresh the stages data
    fetchPaginatedData(currentStage, radiostate); // Refresh the data after submission
    setQueryPartnerId(null);

  }

  const downloadReport = async (format) => {
    try {
      const response = await fetch(
        // `http://localhost:8301/partner-payout-service/reports/download/partner?report_id=${ReportId}&approval_stage_id=${currentStage}&format=${format}`,
        `${Payout_Service}/reports/download/partner?report_id=${ReportId}&approval_stage_id=${currentStage}&format=${format}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + props.accessToken, // Use the access token from props
          },
        }
      );
      if (!response.ok) throw new Error('Network response was not ok');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = format === 'csv' ? 'report.csv' : 'report.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      message.success('Successfully downloaded the report');
      window.URL.revokeObjectURL(url);
    } catch (error) {
      message.error('Download failed:', error);
    }
  };

  const handelnavtolandata = (partner, ReportId) => {

    navigate(`landata/${partner.partnerFirmName}`, {
      state: {
        partnerFirmName: partner.partnerFirmName + "/" + partner.partnerDisplayCode,
        partnerId: partner.partnerId,
        ReportId: ReportId,
        currentStage: currentStage,
      }
    });

  }

  const handleApproveModal = (partnerId) => {
    setIsApproveModal(true);
    setSelectedPartnerId(partnerId);
  };


  const handleApproveSubmit = async () => {
    setIsLoading(true);
    if (approveRemarks.trim() === '') {
      message.error('Please enter remarks before approving.'); // Show error message
      form.resetFields(); // Reset form fields
      setApproveRemarks(''); // Clear the approve remarks input
      return;
    }
    try {
      const partnerid = selectedPartnerId;
      const approvedData = {
        "partnerId": partnerid,
        "reportId": ReportId,
        "userId": props.userDetail?.userId,
        "remarksComment": approveRemarks,
        "stage": 9, // Assuming 8 is the ID for the CET Checker stage
        "remarkType": "PartnerApproved"
      };
      await props.partnerApprovalStagesSuccess({
        accessToken: props.accessToken,
        approvalStageId: 9,
        monthlyReportId: ReportId,
        partnerId: partnerid,
        approveData: approvedData,
      });
      setIsLoading(false)
      await new Promise(resolve => setTimeout(resolve, 500)); // Wait for 500ms to ensure the message is displayed
      message.success('Partner approved successfully!'); // Show success message
      form.resetFields();
      setApproveRemarks(''); // Clear the approve remarks input
      setIsApproveModal(false); // Close the modal
      fetchPayoutStagesData(); // Refresh the stages data
      fetchPaginatedData(currentStage, radiostate); // Refresh the data after submission

      // message.success('Partner approved successfully!'); // Show success message
    } catch (error) {
      console.error("Error submitting approve remarks:", error);
      message.error('Failed to approve partner. Please try again.'); // Show error message
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  const headerMenu = (
    <Menu
      onClick={({ key }) => handleHeaderMenuClick(key)}
      items={[
        { label: 'Export to CSV', key: 'ExportCSV' },
        { label: 'Export to Excel', key: 'ExportExcel' },
        // { label: 'Partner Change History', key: 'PartnerChangeHistory' },
        // { label: 'Add/ View Remark(Partner)', key: 'AddRemark' },
        // { label: 'Raise Query', key: 'Query' },
      ]}
    />
  );

  const columns = [
    // ...(makerAction || checkerAction ? [
    //   {
    //     title: "Check",
    //     dataIndex: "Check",
    //     key: "Check",
    //     fixed: "left",
    //     width: 60,
    //     align:"center",
    //     render: (_, record) => (
    //       <Checkbox
    //         checked={selectedCheckboxes.Check.includes(record)}
    //         onChange={(e) => handleCheckboxChange(e, "Check", record)}
    //       />
    //     ),
    //   },
    // ] : []),
    {
      title: 'Partner Name',
      dataIndex: 'partnerFirmName',
      key: 'partnerFirmName',
      align: "center",
      fixed: "left",
      width: 200,
      render: (_, partner) => (
        // <Link to={`landata/${partner.partnerFirmName}`} style={{ color: "#1b8593", textDecoration: 'none' }}>
        //   {partner.partnerFirmName}
        // </Link>
        <p onClick={() => { handelnavtolandata(partner, ReportId) }} style={{ color: "#1b8593", textDecoration: 'none', }}>
          {partner.partnerFirmName}
        </p>
      ),
    },
    {
      title: 'Partner Code',
      dataIndex: 'partnerDisplayCode',
      key: 'partnerDisplayCode',
      align: "center",
    },
    // {
    //   title: 'Channel Type',
    //   dataIndex: 'ChannelType',
    //   key: 'ChannelType',
    // },
    {
      title: 'Total Disb Amt',
      dataIndex: 'totalDisbAmount',
      key: 'totalDisbAmount',
      align: "center",
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Total Loan Count',
      dataIndex: 'totalDisbCount',
      key: 'totalDisbCount',
      align: "center",
      width: 190,
    },
    {
      title: '1st Disb Amt',
      dataIndex: 'firstDisbAmount',
      key: 'firstDisbAmount',
      align: "center",
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Tranche Disb Amt',
      dataIndex: 'tranchPayout',
      key: 'tranchPayout',
      align: "center",
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Gross Payout',
      dataIndex: 'grossPayout',
      key: 'grossPayout',
      align: "center",
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Payout On Hold',
      dataIndex: 'payoutOnHold',
      key: 'payoutOnHold',
      align: "center",
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Recovery Amount',
      dataIndex: 'recoveryAmount',
      key: 'recoveryAmount',
      align: "center",
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Retro Adj',
      dataIndex: 'retroAdjustment',
      key: 'retroAdjustment',
      align: "center",
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Net Payout',
      dataIndex: 'netPayout',
      key: 'netPayout',
      align: "center",
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    // {
    //   title: 'Net Payout Incl GST',
    //   dataIndex: 'netPayoutWithGst',
    //   key: 'netPayoutWithGst',
    // },
    {
      title: 'Remark',
      dataIndex: 'Remark',
      key: 'Remark',
      align: "center",
      render: (_, partner, key) => (
        <Button className='remarkView-btn' loading={isRemarksLoading === key} style={{ border: "none", color: "#000", fontSize: "12px" }} onClick={() => handleRemarksModal(partner.partnerId, key)} >
          View
        </Button>
      )
    },

    ...(makerAction || checkerAction ? [{
      title: (
        currentStage > 3 ?
          <span style={{ cursor: 'not-allowed', color: '#ccc' }}>
            View <EllipsisOutlined />
          </span>
          :
          <Dropdown overlay={headerMenu} trigger={['click']}>
            <span style={{ cursor: 'pointer' }}>
              View <EllipsisOutlined />
            </span>
          </Dropdown>
      ),
      dataIndex: 'Action',
      key: 'Action',
      align: "center",
      width: 50,
      render: (_, partner) => {
        const menu = (
          <Menu
            onClick={({ key }) => handleMenuClick(partner, key)}
            disabled={partner.documentData ? false : true}
            items={[
              { label: 'Agreement', key: 'Agreement' },
              { label: 'GST Certificate', key: 'GSTCertificate' },
              { label: 'Dual Name Certificate', key: 'DualNameCertificate' },
            ]}
          />
        );

        return (
          <div className='view-container'>
            {/* <Dropdown className="btn" overlay={menu} trigger={['click']}>
              <span> Documents </span>
            </Dropdown> */}
            {currentStage === 2 && (
              <Button className='btn' type="primary" onClick={({ key }) => handelQueryRemarkClick(partner.partnerId)}>
                Raise Query
              </Button>
            )}
            {currentStage === 8 && (
              <Button className='btn' type="primary" onClick={({ key }) => handelQueryRemarkInvoice(partner.partnerId)}>
                Raise Query
              </Button>
            )}
            {currentStage === 8 || currentStage === 10 ?
              <Button disabled={invoiceData ? false : true} className='btn' style={{ marginLeft: "2%" }} type="primary" onClick={({ key }) => handleInvoiceModal(partner)}>
                Invoice
              </Button>
              : ''}
            {currentStage === 8 ? <Button className='btn' type="primary" style={{ marginLeft: "2%", marginRight: "5%" }} onClick={() => handleApproveModal(partner.partnerId)}>
              Approve
            </Button> : null}
            {/* <AddInvoice
              isModalOpen = {isModalOpen}
              setIsModalOpen ={setIsModalOpen}

             /> */}

          </div>
        );
      },
    }] : []),
    ...(utrAction ? [{
      title: 'UTR',
      dataIndex: 'UTRUpdate',
      key: 'UTRUpdate',
      // render: (_, record) => (
      //   <Form onSubmit={handleSubmit}>
      //     <Form.Item
      //       label=""
      //       placeholder="UTRUpdate"
      //       name="UTRUpdate"
      //       style={{ width: "200px", marginTop: "10px", }}
      //     >
      //       <Input
      //         style={{ width: "100%", margin: "0px" }}
      //         placeholder="UTR number"
      //         onChange={handleChange}
      //       />
      //     </Form.Item>
      //   </Form>
      // )
    },
    {
      title: 'Action',
      dataIndex: 'Action',
      key: 'Action',
      render: (_, record) => (
        <Button style={{ marginLeft: 10, backgroundColor: '#1b8593', color: '#fff', fontSize: '0.7rem', margin: '3px', borderRadius: '5px' }} onClick={() => handleSubmit(value, record)}>SAVE</Button>
      )
    }] : [])



  ];
  const handleChange = (event) => {
    // setAddRemarks(event.target.value);
    const value = event.target.value;
    // const words = value.trim().split(/\s+/);
    if (value.length <= 250) {
      setRemarkComment(value);
      setApproveRemarks(value);
    } else {
      // setAddRemarks(value.slice(0, 250).join(' '));
      message.error("You can only enter a maximum of 250 characters.");
    }
  }

  const sortedDatasource = [...datasource].sort((a, b) => {
    const aHasPriority = a.internalQuery || a.anyLanRemapped;
    const bHasPriority = b.internalQuery || b.anyLanRemapped;

    if (aHasPriority === bHasPriority) return 0;
    return aHasPriority ? -1 : 1;
  });

  return (
    <>
      <div style={{ maxWidth: '100%', overflow: "auto" }}>
        {loading && (
          <div style={{
            position: 'absolute',
            zIndex: 10,
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255,255,255,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Spin tip="Loading..." size="large" />
          </div>
        )}
        <Table dataSource={sortedDatasource} pagination={pagination}
          onChange={(pagination) => {
            // Call the parent's handler if provided
            if (props.onPageChange) {
              props.onPageChange(pagination.current, pagination.pageSize, currentStage);
            }
          }} columns={columns} rowKey={(record, index) => index} scroll={{ x: 'max-content', y: 'calc(100vh - 300px)' }}
          rowClassName={(record) => {
            if (record.internalQuery) return 'green-bottom-border';
            if (record.anyLanRemapped) return 'blue-bottom-border';
            return '';
          }}

        />
      </div>

      {/*internal Query Modal */}

      <Modal open={addQueryOpen} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onCancel={handleCancel}>
        <Form
          form={form}
          onFinish={({ QueryRemark }) => {
            setRemarkComment(QueryRemark);
            // handleQueryRemark();
            setMultipleQueryRemark();
          }}
        >
          <Form.Item
            name="QueryRemark"
            label="Query Remark"
            required
            rules={[{ required: true, message: 'Please add Query Remark' },
            {
              validator: (_, value) => {
                if (value && value.split(/\s+/).filter(Boolean).length > 250) {
                  return Promise.reject('Remark cannot exceed 250 characters');
                }
                return Promise.resolve();
              }
            }]}
            style={{ marginBottom: 0 }}
          >
            <TextArea
              style={{ marginTop: 20 }}
              placeholder='Please add Query Remark'
              autoSize={{ minRows: 3, maxRows: 5 }}
              onChange={handleChange}  // Add this line to handle input changes
              value={remarkComment}  // Bind the value to the state
              maxLength={250} // Limit to 250 characters
              showCount={true} // Show character count
            />
          </Form.Item>
          <Button className='btn-query' htmlType="submit" type="primary" >
            Save Query
          </Button>
        </Form>
      </Modal>

      {/*partner Query Modal */}
      <Modal open={addOpenQuery} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onCancel={handleCancel}>
        <Form
          form={form}
          onFinish={({ QueryRemark }) => {
            setRemarkComment(QueryRemark);
            handleQueryRemarkSubmit();
          }}
        >
          <Form.Item
            name="QueryRemark"
            label="Query Remark"
            required
            rules={[{ required: true, message: 'Please add Query Remark' },
            {
              validator: (_, value) => {
                if (value && value.split(/\s+/).filter(Boolean).length > 250) {
                  return Promise.reject('Remark cannot exceed 250 characters');
                }
                return Promise.resolve();
              }
            }]}
            style={{ marginBottom: 0 }}
          >
            <TextArea
              style={{ marginTop: 20 }}
              placeholder='Please add Query Remark'
              autoSize={{ minRows: 3, maxRows: 5 }}
              onChange={handleChange}  // Add this line to handle input changes
              value={remarkComment}  // Bind the value to the state
              maxLength={250} // Limit to 250 characters
              showCount={true} // Show character count
            />
          </Form.Item>
          <Button loading={isloading} className='btn-query' htmlType="submit" type="primary">
            Submit Query
          </Button>
        </Form>
      </Modal>

      <Modal open={isApproveModal} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onCancel={handleCancel}>
        <Form
          form={form}
          onFinish={({ ApproveRemarks }) => {
            setApproveRemarks(ApproveRemarks);
            handleApproveSubmit();
          }}
        >
          <Form.Item
            name="ApproveRemarks"
            label="Approve Remarks"
            required
            rules={[{ required: true, message: 'Please add Query Remark' },
            {
              validator: (_, value) => {
                if (value && value.split(/\s+/).filter(Boolean).length > 250) {
                  return Promise.reject('Remark cannot exceed 250 characters');
                }
                return Promise.resolve();
              }
            }]}
            style={{ marginBottom: 0 }}
          >
            <TextArea
              style={{ marginTop: 20 }}
              placeholder='Please add Approve Remark'
              value={approveRemarks}
              onChange={handleChange}  // Add this line to handle input changes
              autoSize={{ minRows: 3, maxRows: 5 }}
              maxLength={250} // Limit to 250 characters
              showCount={true} // Show character count
            />
          </Form.Item>
          <Button loading={isloading} className='btn-query' htmlType="submit" type="primary">
            Approve
          </Button>
        </Form>
      </Modal>

      <PartnerChangeHistory
        resData={resData}
        partnerChangeOpen={partnerChangeOpen}
        setPartnerChangeOpen={setPartnerChangeOpen}
        partnerChangeData={partnerChangeData}
        setPartnerChangeData={setPartnerChangeData}
      />

      <RemarksComponent
        resData={formatRemarks(partnerRemarks)}
        remarks={remarks}
        setRemarks={setRemarks}
        handelAddRemarks={handelAddRemarks}
        setRemarkComment={setRemarkComment}
        isHistory={checkerAction ? false : true}

      />

      <AddInvoice
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        invoiceData={invoiceData}
        setInvoiceData={setInvoiceData}
        resData={resData}

      />
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPayoutRemarks: (data) => dispatch(getPayoutRemarksSuccess(data)),
    PartnerRemarkadd: (data) => dispatch(addPayoutRemarksSuccess(data)),
    RaiseQuery: (data) => dispatch(getRaisePayoutQueryInternalAction(data)),
    partnerApprovalStagesSuccess: (data) => dispatch(partnerApprovalStagesSuccess(data)),
    getInvoiceData: (data) => dispatch(getInvoiceData(data))
  }
};

const mapStateToProps = (state) => {
  return {
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerListWithPayoutChecker);